import React from "react";
import {
  Csku,
  Tabs,
} from "@commonsku/styles";
import Header from "./Header";
import MainSection from "./MainSection";
import SendVerificationEmail from '../components/tech-support/SendVerificationEmail';
import GeneratePasswordResetLink from '../components/tech-support/GeneratePasswordResetLink';

const TechSupportApp = () => {
  return <>
      <Header />
      <MainSection>
        <div className="main-content">
          <Tabs
            padded={true}
            variant={"secondary"}
            tabs={[
              SendVerificationEmail,
              GeneratePasswordResetLink,
            ].map(
              (Component): { label: string; content: React.ReactNode } => {
                return {
                  label: Component.label,
                  content: <Component/>,
                };
              }
            )}
          />
        </div>
      </MainSection>
  </>;
};

export default TechSupportApp;
